import styled from 'styled-components';
import { WebParaCtaUp } from '../Pages/Webudvikling.styled';

export const SweetBox = styled.div`
  width: 100%;
  max-width: 1200px;
  box-sizing: border-box;
  margin: auto;
  padding: 35px 35px;
  display: flex;
  flex-direction: row;
  border-radius: 20px;
  background: rgb(14, 160, 204);
  background: linear-gradient(
    158deg,
    rgba(14, 160, 204, 1) 0%,
    rgba(9, 179, 195, 1) 44%,
    rgba(100, 199, 219, 1) 100%
  );
  box-shadow: 0 20px 30px 0 rgb(0 0 29 / 7%);
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
  & div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    &:first-child {
      flex-basis: 65%;
      flex-grow: 0;
      flex-shrink: 0;
      & h1 {
        font-size: 2rem;
        color: ${({ theme }) => theme.mainColors.hvid};
        margin: 0;
      }
      & p {
        font-size: 1.25rem;
        color: ${({ theme }) => theme.mainColors.hvid};
        opacity: 0.8;
        font-weight: 400;
      }
      & button {
        margin-top: 25px;
      }
    }
    &:last-child {
      flex-basis: 30%;
      flex-grow: 0;
      flex-shrink: 0;
      & img {
        min-width: 250px;
        max-width: 100%;
      }
    }
  }
`;

export const SweetBoxInnerBig = styled.div`
  flex-basis: 100% !important;
  flex-shrink: 0;
  justify-content: center !important;
  align-items: center !important;
  & ${WebParaCtaUp} {
    max-width: 100%;
  }
`;
